import React from 'react';
import { Formik } from 'formik';
import { Box, Spinner, useToast } from '@chakra-ui/react';
import { localise, templateReplace } from '../../../../services/lang/lang';
import ShareInspectionForm from './ShareInspectionForm';
import { ErrorAwareAlertBox } from '../../../modules/ErrorAwareAlertBox/ErrorAwareAlertBox';
import { getInspectionShareUrl } from '../../../../services/http/endpoints';
import useGenericMutationUseCase from '../../../../hooks/usecases/generic/useGenericMutationUseCase';
import { useUpdateInspectionSettings } from '../../../../services/api/generated/client';
import { Alert } from '../../../modules/Alert/Alert';
import { RenderIf } from '../../../modules/RenderIf/RenderIf';
const ShareInspectionModalContent = ({ inspectionSettings, onClose, isError, error, isLoading, }) => {
    const updateInspectionSettingsUseCase = useGenericMutationUseCase(useUpdateInspectionSettings);
    const toast = useToast();
    if (isError || error) {
        return (React.createElement(Box, { "data-testid": "share_inspection_modal_content_error" },
            React.createElement(ErrorAwareAlertBox, { error: error, noun: localise('INSPECTION_SETTINGS') })));
    }
    if (!inspectionSettings || isLoading) {
        return React.createElement(Spinner, { "data-testid": "share_inspection_modal_content_spinner" });
    }
    const initialFormValues = {
        share_enabled: inspectionSettings.share_enabled,
    };
    const shareUrl = getInspectionShareUrl(inspectionSettings);
    return (React.createElement(Formik, { enableReinitialize: true, onSubmit: (values, helpers) => updateInspectionSettingsUseCase.execute({
            id: inspectionSettings.id,
            data: values,
        }, helpers, {
            onError: () => {
                helpers.resetForm();
            },
            onSuccess: () => {
                toast({
                    status: 'success',
                    title: localise('SHARE_SETTINGS_UPDATED'),
                });
            },
        }), initialValues: initialFormValues },
        React.createElement(React.Fragment, null,
            React.createElement(RenderIf, { condition: updateInspectionSettingsUseCase.isSuccess },
                React.createElement(Alert, { status: "success" }, templateReplace(localise('UPDATED'), {
                    noun: localise('SHARE_SETTINGS'),
                }))),
            React.createElement(ShareInspectionForm, { shareUrl: shareUrl, onClose: onClose }))));
};
export default ShareInspectionModalContent;
